import {useTranslation} from 'react-i18next'
import {useRoleUser} from '../../../../../hooks/useRoleUser'

export const RowHead = () => {
  const {t} = useTranslation()
  const roleUser = useRoleUser()

  return (
    <tr>
      <th>{t('No')}</th>
      <th>{t('Sector')}</th>
      <th>{t('Sales Org')}</th>
      <th>{t('due-date')}</th>
      <th>{t('TableBank.status')}</th>
      <th>{t('Aksi')}</th>
    </tr>
  )
}
